


















































































import { Component, Vue } from 'vue-property-decorator';
import { colors } from '../../styles/constants';
import * as UserSettingService from '../../services/UserSettingService';
import { defaultSpeed, minSpeed, maxSpeed } from '../../services/TextSpeechService';

@Component
export default class SettingsTemplate extends Vue {

    // 発話速度
    private speakerSpeed: number = 0;

    // 画像の初期表示を刻印強調にするフラグ
    private defaultEmphisize = false;

    private speakerSpeedSliderLabels = ['遅く', '',  '標準', '', '早く'];

　　// バーコード読み取り時に利用するカメラ
    private selectLabel = '未選択（既定）'
    private videoDevices: MediaDeviceInfo[] = [];
    private selectedDeviceId: string | null = null;

    public async created(){
        this.videoDevices = await this.getVideoDevices();
        this.selectedDeviceId = UserSettingService.getCameraDeviceId();
    }
    
    public mounted() {
        this.speakerSpeed = UserSettingService.getSpeakerSpeed(defaultSpeed);
        this.defaultEmphisize = UserSettingService.getIsDefaultEmphasize();
    }

    private get speakerMinSpeed() {
        return minSpeed;
    }

    private get speakerMaxSpeed() {
        return maxSpeed;
    }


    private get iconColor() {
        return colors.ffGreen;
    }

    private handleChangeSpeakerSpeed() {
        UserSettingService.setSpeakerSpeed(this.speakerSpeed);
    }

    private handleChangeDefaultEmphasize() {
        this.$store.commit('updateCurrentIsEmphasized', this.defaultEmphisize);
        UserSettingService.setIsDefaultEmphasize(this.defaultEmphisize);
    }

    private async getVideoDevices(): Promise<MediaDeviceInfo[]> {
        const devices = (await navigator.mediaDevices.enumerateDevices())
                        .filter(d => d.kind === 'videoinput');
        return devices;
    }

    private changeDevice(deviceId:string){
        UserSettingService.setCameraDeviceId(deviceId);
    }
}
